<template>
  <Container type="card-full">
    <!-- <div slot="header">
      <menu-btn :menuid="menuid" @btnClick="btnClick"></menu-btn>
    </div> -->
    <vggrid :list="list" tableheight="700" flexname="browsflex"
            :showfooter="false" :showPage="true" :resizable="true"
            :needBlackRow="false" :needPopMenu="false" :canbeEdit="false"
            :total="query.total" @cellClick="cellClick"
            @cellDblClick="cellDblClick" @pagechange="pagechange"
            :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'browsIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        browsform: false,
        brows: {},
        query: {
          comid: this.$store.getters.loginUser.usercomid,
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('ADD', () => this.addBrows())
      this.$on('CHG', () => this.chgBrows())
      this.$on('DEL', () => this.delBrows())
      this.$on('FIELD', () => this.browcols())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.getPageList()
    },
    mounted () {
    },
    watch: {
      async '$route' () {
        this.getPageList()
      }
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.brows = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async browcols () {
        this.$router.push({name: 'browscolForm', params: {form: this.brows}})
      },
      async addBrows () {
        let form = {
          comid: this.$store.getters.loginUser.usercomid,
          browsid: 0
        }
        this.$router.push({name: 'browsForm', params: {form: form, type: 1}})
      },
      async chgBrows () {
        this.$router.push({name: 'browsForm', params: {form: this.brows, type: 2}})
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async delBrows () {
        console.log(this.brows)
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/kfgl/brows/delBrows',
            method: "post",
            data: this.brows
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          }
        })
      },
      async save () {
        await request({
          url: '/kfgl/brows/addOrEdit',
          method: "post",
          data: this.brows
        })
        this.$message.success('操作成功')
        this.browsform = false
        if (!this.brows.browsid) {
          this.query.currPage = 1
        }
        await this.getPageList()
      },
      async cellClick (row) {
        this.brows = row.row
      },
      async cellDblClick (row) {
        this.pod = row.row
        this.$router.push({name: 'browsForm', params: {form: this.brows, type: 3}})
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/kfgl/brows/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
